import { useEffect, useState } from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import IconButton from '@material-ui/core/IconButton'
import CircularProgress from '@material-ui/core/CircularProgress'
import RefreshIcon from '@material-ui/icons/Refresh'

import {
  Avatar
} from '@material-ui/core'
import { toast } from 'react-toastify'
import api from '../../services/api'
import { ButtonSecondary } from '../ButtonSecondary'
import { useStyles } from './style'

const ContactAvatarModal = ({
  open,
  onClose,
  avatarUrl,
  alt,
  contactId,
  onAvatarUpdate
}) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (open) {
      handleUpdateProfilePic()
    }
  }, [open, contactId])

  const handleClose = () => {
    onClose()
  }

  const handleUpdateProfilePic = async () => {
    if (!contactId) return

    setLoading(true)
    try {
      const { data } = await api.put(
        `/contacts/${contactId}/update-profile-pic`
      )

      if (onAvatarUpdate) {
        onAvatarUpdate(data.contact.profilePicUrl)
      }

      // toast.success('Imagem de perfil atualizada com sucesso!')
      // handleClose()
    } catch (error) {
      console.error('Erro ao atualizar imagem de perfil:', error)
      toast.error('Erro ao atualizar imagem de perfil')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={classes.root}>
      <Dialog open={open} onClose={handleClose} scroll="paper">
        <DialogContent>
          <div className={classes.avatarContainer}>
            <Avatar src={avatarUrl} alt={alt} className={classes.largeAvatar} />
          </div>
          <div className={classes.actionButtons}>
            {contactId && (
              <IconButton
                onClick={handleUpdateProfilePic}
                disabled={loading}
                className={classes.refreshButton}
                title="Atualizar imagem do WhatsApp"
              >
                {loading ? (
                  <CircularProgress size={20} />
                ) : (
                  <RefreshIcon />
                )}
              </IconButton>
            )}
          </div>
          <div className={classes.closeButton}>
            <ButtonSecondary label="Cancelar" onClick={handleClose} />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default ContactAvatarModal